/**
 * Utility functions for wallet operations
 */

/**
 * Format address for display (truncate middle)
 */
export function formatAddress(address: string, chars: number = 4): string {
  if (!address || address.length < 10) return address;
  return `${address.slice(0, chars + 2)}...${address.slice(-chars)}`;
}

/**
 * Format balance for display
 */
export function formatBalance(
  balance: bigint,
  decimals: number = 18,
  precision: number = 4
): string {
  const divisor = BigInt(10 ** decimals);
  const integerPart = balance / divisor;
  const fractionalPart = balance % divisor;

  const fractionalStr = fractionalPart
    .toString()
    .padStart(decimals, '0')
    .slice(0, precision);

  return `${integerPart}.${fractionalStr}`;
}

/**
 * Check if string is a valid Ethereum address
 */
export function isValidAddress(address: string): boolean {
  return /^0x[a-fA-F0-9]{40}$/.test(address);
}

/**
 * Normalize an Ethereum address to checksum format
 */
export function normalizeAddress(address: string): string {
  if (!isValidAddress(address)) {
    throw new Error('Invalid Ethereum address');
  }
  return address.toLowerCase();
}
